import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=2465762b&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=2465762b&prod&scoped=true&lang=css&"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=2465762b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465762b",
  null
  
)

export default component.exports